import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { SberOprosResult } from 'Modules'
import { SimpleResponse } from 'Types/simpleResponse'

export const sberOprosApi = {
	sendFeedback: async (data: SberOprosResult) => {
		const res = await axiosDS().patch<SimpleResponse>(urls.user.widget.set_feedback, {
			widget: { result: data },
		})
		return res.data
	},
}
